<h2 mat-dialog-title [innerHTML]="title"></h2>
<mat-dialog-content [formGroup]="form">
  <p class="mt-0" [innerHTML]="textContent"></p>

  @for (date of dates; track date) {
    <fieldset>
      <mat-form-field>
        <mat-label>{{ date.label }} :</mat-label>
        <input type="date" matInput
          id="{{ date.identifier }}"
          formControlName="{{ date.identifier }}"
          [min]="form.controls[date.afterIdentifier]?.value ?? date.min"
          [max]="form.controls[date.beforeIdentifier]?.value ?? date.max"
          >
        </mat-form-field>
        @if (data.shortcuts) {
          <div>
            @for (shortcut of data.shortcuts; track shortcut) {
              <button mat-stroked-button
                (click)="applyShortcut(date, shortcut.value)" class="ml-3 mat-button-small">
                {{ shortcut.label }}
              </button>
            }
          </div>
        }
      </fieldset>
    }

    @if (showComment) {
      <fieldset>
        <mat-form-field class="w-100">
          <mat-label>{{ titleComment }} :</mat-label>
          <textarea
            id="comment"
            matInput
            class="w-100"
            formControlName="comment"
            required
            cdkTextareaAutosize
            rows="5"
          ></textarea>
        </mat-form-field>
      </fieldset>
    }

    @if (data.dangerContent) {
      <div class="alert alert-danger mt-3">
        <div [innerHTML]="data.dangerContent | safeHtml"></div>
      </div>
    }

    @if (data.helpContent) {
      <div class="alert alert-light mt-3">
        <div [innerHTML]="data.helpContent | safeHtml"></div>
      </div>
    }

    @if (form.errors?.customError) {
      <p class="alert alert-danger">
        {{ form.errors?.customError }}
      </p>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (cancel) {
      <button mat-button [mat-dialog-close]="null">{{ cancel }}</button>
    }
    <button mat-raised-button color="accent" [disabled]='!form.valid || disableValidButton()'
      [mat-dialog-close]="form.value">{{ confirm }}
    </button>
  </mat-dialog-actions>
